<template>
  <svg
    :class="className"
    fill="none"
    :height="height"
    viewBox="0 0 16 16"
    :width="width"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="8" cy="8" :fill="fill" r="8"/>
    <rect fill="white" height="9" rx="1" transform="rotate(45 11.4854 4.12109)" width="2" x="11.4854" y="4.12109"/>
    <path d="M7.9502 10.4854L6.53598 11.8996L3.70755 9.07114C3.31703 8.68061 3.31703 8.04745 3.70756 7.65692C4.09808 7.2664 4.73124 7.2664 5.12177 7.65692L7.9502 10.4854Z" fill="white"/>
  </svg>
</template>

<script>
export default {
  name: 'FixedPrice',
  props: {
    width: {
      type: String,
      required: false,
      default: '16'
    },
    height: {
      type: String,
      required: false,
      default: '16'
    },
    className: {
      type: String,
      required: false,
      default: ''
    },
    fill: {
      type: String,
      required: false,
      default: '#FF981F'
    },
  },
};
</script>
